module.exports = __webpack_public_path__ + "static/img/bg.47c70d31.svg";